import { Component, OnInit, Input } from "@angular/core";
import { SubscriptionService } from "../../providers/subscription.service";
import { RoutingService } from "../../providers/routing.service";
import { BvDialogService } from "../../design-system";

import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-sub-required",
    templateUrl: "./sub-required.component.html",
    styleUrls: ["./sub-required.component.scss"],
    imports: [TranslateModule]
})
export class SubRequiredComponent implements OnInit {
  @Input() bvTextLink!: boolean;
  constructor(
    public subServ: SubscriptionService,
    private routing: RoutingService,
    private dialog: BvDialogService
  ) {}

  ngOnInit() {}
  gotoSub() {
    this.dialog.closeAll();
    this.routing.toSubscription();
  }
}
